"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t$1=require("react");function t(){let[e,r]=t$1.useState(null);return{anchorEl:e,handleClose:()=>r(null),toggle:e=>r(e.currentTarget)}}exports.default=t;
//# sourceMappingURL=useAnchorState.js.map
